import { sftpConnectorPrefix, SftpTestConnectionPayload, urlCombine } from 'ihub/common';
import { handleResponse, microServiceAPI, standardPost } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class SftpReaderHttpService {
	private testConnectionPath = 'TestConnection';

	async testConnection(item: SftpTestConnectionPayload, options?: HttpResponseOptions) {
		const url = urlCombine(microServiceAPI, sftpConnectorPrefix, this.testConnectionPath);
		const response = await standardPost(url, item);
		await handleResponse(response, 'Test Connection', sftpConnectorPrefix, options);
	}
}
